<template>
  <div class="hidden-danger-quality-district-chart">
    <custom-panel>
      <template #title>隐患数量区域分布</template>
      <template #default>
        <dv-charts :option="option" v-if="dataLoaded"/>
      </template>
    </custom-panel>
  </div>
</template>

<script>
import CustomPanel from '@/components/custom-panel/index.vue'
import request from '@/util/request.js'

export default {
  components: {
    CustomPanel
  },
  data () {
    return {
      timer: null,
      dataLoaded: false,
      option: {
        title: {},
        xAxis: {
          data: [/* '大鹏新区', '宝安区', '龙华新区', '罗湖区', '龙岗区', '福田区', '南山区', '盐田区', '坪山新区', '光明新区', '深汕特别合作区' */],
          axisLabel: {
            style: {
              fill: '#fff',
              rotate: -45
            }
          }
        },
        yAxis: {
          data: 'value',
          axisLabel: {
            style: {
              fill: '#fff'
            },
            formatter: function ({ value }) {
              return parseInt(value)
            }
          }
        },
        series: [
          {
            data: [/* 16, 22, 18, 8, 17, 20, 12, 29, 15, 10, 29 */],
            type: 'bar',
            gradient: {
              color: ['#5c52c3', '#6cd1f4']
            },
            label: {
              show: true,
              style: {
                fill: '#fff'
              }
            }
          }
        ]
      }
    }
  },
  created () {
    this.getYinHuanShuLiangQuYuFenBu()
  },
  methods: {
    async getYinHuanShuLiangQuYuFenBu () {
      const res = await request.get('/common/yin-huan-shu-liang-qu-yu-fen-bu')
      this.option.xAxis.data = res.data.map((item) => {
        return item.district
      })
      this.option.series[0].data = res.data.map((item) => {
        return item.count
      })
      this.dataLoaded = true
    }
  },
  mounted () {
    this.timer = setInterval(() => {
      this.getYinHuanShuLiangQuYuFenBu()
    }, process.env.VUE_APP_DATA_REFRESH_INTERVAL)
  },
  beforeDestroy () {
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
  }
}
</script>

<style lang="scss" scoped>
.hidden-danger-quality-district-chart {
  height: 100%;
}
</style>
